module.exports = __webpack_public_path__ + "static/media/8900_FirstFloor.97fb4a45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_FirstFloor.jpg
// module id = 575
// module chunks = 0